import { Component, Input, OnInit } from '@angular/core';
import { PaymentRequestDto } from '@app/model/payment-request/payment-request.dto';
import { TermsLinkService } from '@app/service/terms-link/terms-link.service';

@Component({
  selector: 'app-se-terms',
  templateUrl: './se-terms.component.html',
  styleUrls: ['./se-terms.component.scss', '../page-shared.css'],
})
export class SeTermsComponent implements OnInit {
  constructor(public termsLinkService: TermsLinkService) {}

  @Input() paymentRequest: PaymentRequestDto;

  ngOnInit() {}
}
